import ICO_PHONE from '@/assets/images/footer/ico-service.png';
import ICO_TIME from '@/assets/images/footer/ico-time2.png';
import ICO_QRCODE from '@/assets/images/footer/ico-qrcode.png';
import WECHAT_QRCODE from '@/assets/images/footer/wechat-qrcode.png';

const locatUrl =
  location.origin + (process.env.NODE_ENV === 'development' ? '' : '/edu');
export const footerData = {
  title: 'WPS数字化教育解决方案',
  subtitle: '开启WPS 365 教育版，畅享一体化教学办公管理体验',
  icon: '',
  contact: {
    phone: {
      label: '客服电话',
      value: '400-677-5005',
      icon: ICO_PHONE,
    },
    time: {
      label: '服务时间',
      value: '周一到周五：9:00 - 18:00',
      icon: ICO_TIME,
    },
    qr: {
      label: '扫码联系客服',
      img: WECHAT_QRCODE,
      icon: ICO_QRCODE,
    },
  },
  copyright: {
    top1: '© 2008-2025 Kingsoft Office Software, Inc. All Rights Reserved.',
    top2: '粤公网安备44049102496073号',
    top3: '粤ICP备13015957号',
    top4: '营业执照',
    bottom1: '官方举报电话（含互联网算法推荐举报）：4006775005',
  },
  guideList: [
    {
      name: '产品定价',
      info: 'price',
      list: [
        {
          label: '体验版',
          url: locatUrl + '/price',
          event: 'bottom_365trial',
        },
        {
          label: 'WPS 365 教育标准版',
          url: locatUrl + '/price',
          event: 'bottom_365standard',
        },
        {
          label: 'WPS 365 教育高级版',
          url: locatUrl + '/price',
          event: 'bottom_365application',
        },
        {
          label: 'WPS 365 教育旗舰版',
          url: locatUrl + '/price',
          event: 'bottom_365flagship',
        },
      ],
    },
    {
      name: '用户支持',
      info: 'support',
      list: [
        {
          label: '帮助中心',
          url: locatUrl + '/help',
          event: 'bottom_help',
        },
        // {
        //   label: '下载中心',
        //   url: 'https://365.wps.cn/download'
        // },
        {
          label: '服务协议',
          url: 'https://privacy.wps.cn/policies/agreements/wps365',
          event: 'bottom_service_agreement',
        },
        {
          label: '安全白皮书',
          url: 'https://www.kdocs.cn/l/cmbYWqWZEXX9',
          event: 'bottom_safe',
        },
        {
          label: '更新日志',
          url: 'https://365.kdocs.cn/wiki/l/0lcqeYiD3yC9AD/qa/?from=grouptitle',
          event: 'bottom_update_log',
        },
      ],
    },
    {
      name: '资源与社区',
      info: 'community',
      list: [
        // {
        //   label: 'WPS图文教程',
        //   url: 'https://plus.wps.cn/blog/jiaocheng',
        //   event: 'bottom_wps_course'
        // },
        {
          label: '培训与认证',
          url: 'https://365.wps.cn/train',
          event: 'bottom_train',
        },
        // {
        //   label: '资讯中心',
        //   url: 'https://plus.wps.cn/news/',
        //   event: 'bottom_news'
        // },
        {
          label: 'WPS官网',
          url: 'https://www.wps.cn',
          event: 'bottom_wps_official_web',
        },
        {
          label: 'WPS Office 2023教育版',
          url: locatUrl + '/2023/home',
          event: 'bottom_365flagship',
        },
      ],
    },
    {
      name: '政企服务',
      info: 'service',
      list: [
        {
          label: '私有化方案',
          url: 'https://ep.wps.cn',
          event: 'bottom_privatization',
        },
        {
          label: 'WPS开放平台',
          url: 'https://open.wps.cn',
          event: 'bottom_open_platform',
        },
      ],
    },
  ],
};
